import { Col, Row } from 'react-bootstrap';
import Pathway from './Pathways/Pathway';

export default function Pathways() {


  return (
    <Row>
      <Col>
        <Pathway title="Engaging Humor" />
        <Pathway title="Innovative Planning" progress={100} />
      </Col>
    </Row>
  )
}